<template>
  <div class="order-detail">
    <div class="head">
      <AppFrame/>
    </div>
    <div class="cont">
      <van-cell-group>
        <van-cell title="">
          <template #label>
            <van-card>
              <template #thumb>
                <div class="van-image">
                  <img v-if="orderInfo.driver_img" :src="orderInfo.driver_img" class="van-image__img">
                </div>
              </template>
              <template #title>
                <div class="van-card__title">
                  <span>{{orderInfo.driver_name}} </span>&nbsp;<span> {{orderInfo.driver_tel}}</span>
                </div>
              </template>
              <template #desc>
                <div class="van-card__desc">
                  <span>{{orderInfo.license_plate}}</span>
                </div>
              </template>
            </van-card>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-cell title="">
          <template #label>
            <div class="order-detail-info">
              <div>
                <span>派车单号：</span>
                <span>{{orderInfo.num}}</span>
              </div>
              <div>
                <span>装货时间：</span>
                <span>{{orderInfo.loadingTime | timeFormat}}</span>
              </div>
              <div>
                <span>卸货时间：</span>
                <span>{{orderInfo.unLoadingTime | timeFormat}}</span>
              </div>
              <div>
                <span>承运单位：</span>
                <span>{{orderInfo.consignee_cust_name}}</span>
              </div>
              <div>
                <span>发货单位：</span>
                <span>{{orderInfo.shipper_name}}</span>
              </div>
              <div>
                <span>发货地点：</span>
                <span>{{orderInfo.shipper_alias}}</span>
              </div>
              <div>
                <span>收货单位：</span>
                <span>{{orderInfo.consignee_name}}</span>
              </div>
              <div>
                <span>收货地点：</span>
                <span>{{orderInfo.consignee_alias}}</span>
              </div>
              <div>
                <span>货品名称：</span>
                <span>{{orderInfo.pname}}</span>
              </div>
              <div>
                <span>实发数量：</span>
                <span>{{orderInfo.receiving_num}}{{orderInfo.quantity_unitid_name}}</span>
              </div>
              <div>
                <span>实收数量：</span>
                <span>{{orderInfo.unloading_num}}{{orderInfo.quantity_unitid_name}}</span>
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-cell title="">
          <template #label>
            <div class="order-detail-steps">
              <van-steps
                direction="vertical"
                :active="0"
                active-icon="logistics"
                inactive-icon="logistics"
              >
                <van-step
                  v-for="(item, index) in orderInfoSteps"
                  :key="index">
                  <template #active-icon>
                    <span class="active-icon"></span>
                  </template>
                  <template #inactive-icon>
                    <span class="inactive-icon"></span>
                  </template>
                  <p class="van-steps--time">
                    <span class="title">{{item.action_date}}</span>
                    <span class="desc">{{item.action_time}}</span>
                  </p>
                  <div class="van-steps-info-title">{{item.actionName}}</div>
                  <div>实发数  {{item.dispatched_num}}</div>
                  <div>里程数  {{item.mileage}}</div>
                  <div class="van-steps-info-pz">
                    <div class="label">凭证</div>
                    <van-uploader v-model="orderInfoSteps.fileList[index]" multiple :deletable="false" :show-upload="false"/>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </template>
        </van-cell>
      </van-cell-group>

    </div>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
import base from '@/api/base'
export default {
  name: "SendcarsDetail",
  components: {
    AppFrame
  },
  data() {
    return {
      currentPage: 1,
      showCount: 3, //每页个数
      fileList: [
        { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
      ],
      orderInfo:{},
      orderInfoSteps:[]
    };
  },
  created() {
    this.tId = this.$route.params.id
    console.log(this.tId)
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
    this.getOrderInfo()
    this.getTransRecordDetail()
  },
  mounted() {
  },
  methods: {
    // 获取派车单详情
    getOrderInfo () {
      let data = {
        dispatchOrderId: this.tId,        //发货单号
        currentPage: this.currentPage, // 当前页数
        showCount: this.showCount    //显示个数
      };
      this.$api.apis.getTrafficDispatchOrderFromSupply(data).then(res => {
        if(res&&res.rsObj&&res.rsObj.dispatchOrderList&&res.rsObj.dispatchOrderList.length>0){
          this.orderInfo = res.rsObj.dispatchOrderList[0]
        }else{
          this.$toast.fail(res.msg);
        }
      });
    },
    // 获取派车单详情步进器列表
    getTransRecordDetail () {
      let data = {
        dispatchId: this.tId,        //发货单号
      };
      this.$api.apis.getTransRecordDetail(data).then(res => {
        console.log(res)
        if(res.rsObj){
          this.orderInfoSteps = res.rsObj
          this.orderInfoSteps.fileList = this.orderInfoSteps.map(item =>{
            let arrs = []
            let ip = base.baseImgUrl
            if(item.image1)arrs.push({ url: ip + item.image1 })
            if(item.image2)arrs.push({ url: ip + item.image2 })
            if(item.image3)arrs.push({ url: ip + item.image3 })
            if(item.image4)arrs.push({ url: ip + item.image4 })
            return arrs
          })
        }else{
          this.$toast.fail(res.msg);
        }
      });
    },
  },
  filters: {
    imgList : (value) => {
      let result = [];
      result = value.map(item =>{
        url: item.pimage
      })
      return result;
    },
    timeFormat : (value) => {
      if(!value) return ''
      let date = new Date(new Date(value.replace(/-/g, '/').replace(/T/g, ' ').substr(0, value.indexOf('.'))).getTime() + 3600 * 1000 * 8)
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let h = date.getHours();
      let min = date.getMinutes();
      let s = date.getSeconds();
      let result = "";
      return result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
          h < 10 ? "0" + h : h
          }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/orderDetail.less';
</style>



// WEBPACK FOOTER //
// src/pages/Sendcars/SendcarsDetail.vue